import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Modal from 'sharedComponents/Modal';
import Icon from 'sharedComponents/Icon';
import { validate, validationSchema } from 'forms/videoForm';
import useUploadFile from 'reducers/hooks/useUploadFile';
import useScreen from 'hooks/useScreen';

import Uploader from './components/Uploader';
import Error from './components/Error';

import useStyles from './useStyles';

const DEFAULT_DESKTOP_WIDTH = '500';
const DEFAULT_MOBILE_WIDTH = '250';

const INITIAL_STATE = {
  videoUrl: '',
  errors: [],
  valid: false,
};

const VideoUploader = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { videoFile, onSend, onClose, type } = props;
  const [state, setState] = useState(INITIAL_STATE);
  const { uploadFileToS3, isVideoUploading, uploadProgress } = useUploadFile();

  const typeMapper = {
    upload: {
      label: t('components.VideoUpload.uploadVideoTitle'),
      button: t('components.VideoUpload.uploadVideoButtonText'),
    },
    send: {
      label: t('components.VideoUpload.sendVideoTitle'),
      button: (
        <span className={classes.button}>
          <Icon name="plane" className={classes.icon} />
          {t('components.VideoUpload.sendVideoButtonText')}
        </span>
      ),
    },
  };

  const deleteUrl = () => {
    URL.revokeObjectURL(state.videoUrl);
  };

  useEffect(() => {
    const { valid, errors } = validate(videoFile, validationSchema);
    const videoUrl = URL.createObjectURL(videoFile);
    setState({ ...state, videoUrl, valid, errors });
    return deleteUrl;
  }, []);

  const buildCachedVideo = fields => {
    return {
      id: fields.key.match(/^cache\/(.+)/)[1],
      storage: 'cache',
      metadata: {
        size: videoFile.size,
        filename: videoFile.name,
        mimeType: videoFile.type,
      },
    };
  };

  const uploadVideo = async () => {
    const params = { type: videoFile.type, filename: videoFile.name };
    const cachedFileFields = await uploadFileToS3(params, videoFile);
    const cachedVideo = buildCachedVideo(cachedFileFields);
    onSend(cachedVideo);
  };

  const handleSend = () => {
    uploadVideo();
  };

  const handleCLose = () => {
    if (isVideoUploading) return;
    onClose();
  };

  const { errors, valid } = state;
  const width = isDesktop ? DEFAULT_DESKTOP_WIDTH : DEFAULT_MOBILE_WIDTH;

  return (
    <Modal onClose={handleCLose} label={typeMapper[type].label} closeButton header>
      {valid ? (
        <Uploader
          videoUrl={state.videoUrl}
          uploading={isVideoUploading}
          uploadProgress={uploadProgress}
          onSend={handleSend}
          width={width}
          buttonContent={typeMapper[type].button}
        />
      ) : (
        <Error width={width} errors={errors} onClose={handleCLose} />
      )}
    </Modal>
  );
};

VideoUploader.propTypes = {
  videoFile: PropTypes.shape().isRequired,
  onClose: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  type: PropTypes.string,
};

VideoUploader.defaultProps = {
  type: 'send',
};

export default VideoUploader;



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoUploader/VideoUploader.js